<template>
    <div
        v-if="tenant"
        :id="id"
        class="receipt"
    >
        <receipt-credit-note
            v-if="order.isCreditNote()"
            :order="order"
            :options="options"
        />

        <template v-else-if="options.forceInvoiceForm">
            <template v-if="locale === 'sr'">
                <receipt-invoice-sr
                    v-if="order.isFiscal()"
                    :order="order"
                    :options="options"
                />

                <receipt-einvoice
                    v-else
                    :order="order"
                    :options="options"
                />
            </template>

            <receipt-invoice-ba
                v-else-if="locale === 'ba'"
                :order="order"
                :options="options"
            />

            <receipt-invoice-me
                v-else
                :order="order"
                :options="options"
            />
        </template>

        <receipt-default
            v-else
            :order="order"
            :options="options"
        />
    </div>
</template>

<script>
import ReceiptDefault from '@/components/print/ReceiptDefault';
import ReceiptCreditNote from '@/components/print/ReceiptCreditNote';
import ReceiptInvoiceMe from '@/components/print/ReceiptInvoiceMe';
import ReceiptInvoiceSr from '@/components/print/ReceiptInvoiceSr';
import ReceiptInvoiceBa from '@/components/print/ReceiptInvoiceBa';
import ReceiptEinvoice from '@/components/print/ReceiptEinvoice';
import EinvoiceService from '@/services/EinvoiceService';

export default {
    components: {
        ReceiptDefault,
        ReceiptCreditNote,
        ReceiptInvoiceMe,
        ReceiptInvoiceSr,
        ReceiptInvoiceBa,
        ReceiptEinvoice
    },

    props: {
        id: {
            type: String,
            default: 'receipt'
        },
        order: {
            type: Object,
            default: () => null
        },
        options: {
            type: Object,
            default: () => {}
        },
    },

    computed: {
        einvoiceOnly() {
            return EinvoiceService.einvoiceOnly();
        }
    }
};
</script>

<style lang="scss" scoped>
.receipt {
    height: 100%;
}
</style>
